import { createSelector } from "reselect";

const tutorialsSelector = state => state.tutorials;

export const getIsShowWatchMoreVideosLaterTooltip = createSelector(
    tutorialsSelector, tutorials => tutorials.isShowWatchMoreVideosLaterTooltip
);

export const getIsFirstShowIntro = createSelector(
    tutorialsSelector, tutorials => tutorials.isFirstShowIntro
);
